// React
import React from 'react';
import PropTypes from 'prop-types';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';
import AccountStore from 'stores/AccountStore';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';

class DialogManageAccounts extends React.PureComponent {

    state = {
        accounts: AccountStore.getAccounts(),
        isLoading: AccountStore.isLoading(),
        filter: null
    };

    static propTypes = {
        close: PropTypes.func,
        open: PropTypes.bool,
        accountsSelected: PropTypes.array,
        addAccount: PropTypes.func,
        deleteAccount: PropTypes.func,
        classes: PropTypes.object,
        fullScreen: PropTypes.bool
    };

    componentDidMount() {
        AccountStore.addChangeListener(this.onAccountChange);
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    onAccountChange = () => {
        if (!this.mounted) {
            return false;
        }

        this.setState({
            accounts: AccountStore.getAccounts(),
            isLoading: AccountStore.isLoading()
        });
    };

    close = () => {
        this.props.close();
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    renderAccountSelected(){
        if (!this.state.filter) {
            return this.props.accountsSelected.map(account => <Chip key={account.name} label={account.name} onDelete={() => this.props.deleteAccount(account.id)} color='primary' />);
        }

        return this.props.accountsSelected.map((account) => {
            if (account.name.toLowerCase().startsWith(this.state.filter.toLowerCase())) {
                return <Chip key={account.name} label={account.name} onDelete={() => this.props.deleteAccount(account.id)} color='primary' />;
            }
            return null;
        });
    }

    renderAccounts(){
        const { accounts } = this.state;

        const accountsToDisplay = accounts.filter(account => this.props.accountsSelected.findIndex(a => account.id === a.id) === -1);

        if (!this.state.filter) {
            return accountsToDisplay.map(account => <Chip key={account.name} label={account.name} onDelete={() => this.props.addAccount(account)} deleteIcon={<AddIcon />} />);
        }
        return accountsToDisplay.map((account) => {
            if (account.name.toLowerCase().startsWith(this.state.filter.toLowerCase())) {
                return <Chip key={account.name} label={account.name} onDelete={() => this.props.addAccount(account)} deleteIcon={<AddIcon />} />;
            }
            return null;
        });
    }

    render() {
        const { fullScreen, classes } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.props.close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
                classes={{
                    paper: classes.dialogPaper
                }}
            >
                <DialogTitle id='responsive-dialog-title' className={classes.dialogTitle}>{translate.i18n('MANAGE_ACOUNTS_FOR_USER')}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <div>
                        <TextField className={ classes.searchBar } label='Search' variant='standard' onChange={(event) => this.setState({ filter : event.target.value }) }/>
                    </div>
                    <div className={ classes.accountsList }>
                        {this.renderAccountSelected()}
                        {this.renderAccounts()}
                    </div>
                </DialogContent>
                <DialogActions>
                    <IconButton color='primary' onClick={this.props.close} className={classes.closeButton}>
                        <DoneIcon />
                    </IconButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = () => ({
    accountsList: {
        '& > *': {
            margin: '4px',
        }
    },
    dialogContent: {
        overflow: 'auto',
        width: '100%',
        paddingRight: '16px',
        paddingLeft: '16px',
    },
    dialogPaper: {
        minHeight: '94%',
        minWidth: '32%'
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: '5px'
    },
    searchBar: {
        width: '95%',
        marginLeft: '13px',
        marginBottom: '10px'
    },
    leftIcon: {
        marginRight: '8px',
        fontSize: 20
    }
});

export default withStyles(styles)(DialogManageAccounts);
